/**
 * Fetches Shopify product recommendations section HTML and injects into a <ul>.
 * GET /recommendations/products?product_id=&section_id=&limit=&intent=
 */
if (typeof ProductRecommendations === 'undefined') {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.isLoaded = false;
    }

    connectedCallback() {
      if (this.isLoaded) return;

      const url = this.dataset.url;
      if (!url) return;

      const ul = this.querySelector('ul');
      if (!ul) return;

      const hasRealItems = [...ul.children].some(
        (li) =>
          !li.classList.contains('skeleton-list-item') &&
          li.querySelector('[data-product-card-link], .cart-upsell-card')
      );
      if (hasRealItems) {
        this.isLoaded = true;
        return;
      }

      fetch(url)
        .then((response) => {
          if (!response.ok) throw new Error('HTTP ' + response.status);
          return response.text();
        })
        .then((text) => {
          const wrapper = document.createElement('div');
          wrapper.innerHTML = text;
          const next = wrapper.querySelector('ul');
          if (!next || !next.innerHTML.trim().length) {
            this.hidden = true;
            return;
          }
          const items = [...next.querySelectorAll(':scope > li')];
          if (!items.length) {
            this.hidden = true;
            return;
          }
					ul.replaceChildren(...items);
					if (window.jQuery && jQuery.fn.niceSelect) {
						jQuery(ul).find('.cart-upsell-card__select').each(function () {
							const $select = jQuery(this);
							if (!$select.next('.nice-select').length) {
								$select.niceSelect();
							}
						});
					}
				})
        .catch((e) => {
          console.error('Error fetching product recommendations:', e);
          this.hidden = true;
        })
        .finally(() => {
          this.isLoaded = true;
        });
    }
  }

  if (!window.customElements.get('product-recommendations')) {
    window.customElements.define('product-recommendations', ProductRecommendations);
  }
}
